<script>
	import { Col } from "@sveltestrap/sveltestrap";
	import CustomButton from "../../../components/CustomButton/CustomButton.svelte";
	import { navigate } from "svelte-routing";
	import { assignableTasks, assignState, canAssign } from "src/store/store";
	import { arrayToQueryParams } from "src/utils/misc";
	import queryString from "query-string";

	let taskIds = [];
	let isAssignState = false;
	let canAssignBool;

	let assign = () => {
		assignState.set(true);
	};

	function cancelAssign() {
		assignState.set(false);
	}

	function navigateToAssign() {
		let queryParams = queryString.stringify(
			arrayToQueryParams({ taskIds })
		);
		navigate(`/jobs/assign?${queryParams}`);
		assignState.set(false);
	}

	assignState.subscribe((value) => {
		isAssignState = value;
	});

	assignableTasks.subscribe((value) => {
		taskIds = value;
	});

	canAssign.subscribe((value) => {
		canAssignBool = value;
	});
</script>

<Col class="d-flex flex-row-reverse" style="height: 70px">
	{#if isAssignState}
		<div class="mx-2">
			<CustomButton
				buttonText="Next"
				on:click={navigateToAssign}
				disabled={!taskIds.length}
				color="primary"
			/>
		</div>
		<div>
			<CustomButton buttonText="Cancel" on:click={cancelAssign} />
		</div>
	{:else}
		<div class="mx-2">
			<CustomButton
				buttonText="Assign"
				color="primary"
				on:click={assign}
				disabled={!canAssignBool}
			/>
		</div>
		<div class="mx-2">
			<CustomButton
				buttonText="Create task"
				on:click={() => navigate("/jobs/create-task")}
			/>
		</div>
	{/if}
</Col>
